import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function SolutionsComparison() {
  return <section className="mb-16" data-id="element-220">
      <h2 className="text-2xl font-bold mb-6 text-blue-900" data-id="element-221">
        Why Traditional "Solutions" Failed
      </h2>
      <div className="text-lg mb-6" data-id="element-222">
        <p className="mb-4" data-id="element-223">Like thousands of cat owners, Margaret did everything the "experts" told her:</p>
        <ul className="list-disc  pl-6 text-lg space-y-2" data-id="element-224">
          <li data-id="element-225">
            {' '}
            <strong data-id="element-226">HEPA purifiers:</strong> She spent nearly <strong data-id="element-227"> $800 on a bulky tower </strong> that
             sounded like a jet engine and still missed the tiniest allergen particles floating 
             in the air. [6] <em data-id="element-228">“I tried a $700 purifier and it barely made a difference.”</em>
              And the kicker? Filters cost another <strong data-id="element-229">$150 every six months.</strong>
          </li>
          <li data-id="element-230">
            <span className="font-bold" data-id="element-231">Allergy Medications:</span> Sure, they dulled the symptoms… 
            but left her groggy and exhausted. <em data-id="element-232">“Allergy tablets just knock me out — I need something natural.”</em>
          </li>
          <li data-id="element-233">
            <span className="font-bold" data-id="element-234">Deep Cleaning services:</span> After one $900 “allergen removal” 
            session, the air felt fresh for a day — but within 48 hours, the sneezing was back. 
            Dander particles are too light to stay gone.
          </li>
        </ul>
      </div>
      <div classname="text-lg mb-6" data-id="element-235">
      <p className="mb-4" data-id="element-236">After years of wasted money and disappointment, Margaret admitted what many cat parents secretly believe:</p>
      </div>
      <blockquote className="border-l-4 border-blue-500 pl-4 italic text-xl mb-8" data-id="element-237">
        "Most of these so-called solutions are nothing but a scam"
      </blockquote>
      <div className="text-center" data-id="element-238">
        <p className="mb-4 text-lg text-blue-800 text-center" data-id="element-239">
          Finally Breathe Easy Around Your Cat
        </p>
        <a href="https://petssey.com/products/petssey-dnrx" className="inline-flex items-center px-8 py-4 text-xl font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 transition-colors" data-id="element-240">
          <span className="mr-2" data-id="element-241">Try Risk-Free</span>
          <ArrowRightIcon size={20} data-id="element-242" />
        </a>
      </div>
      <div className="mt-12" data-id="element-243">
        <h2 className="text-2xl font-bold mb-6 text-blue-900" data-id="element-244">
          The Breakthrough Discovery
        </h2>
        <div className="text-lg mb-6" data-id="element-245">
          <p className="mb-4" data-id="element-246">
            One afternoon, Margaret confided in her neighbour Susan — another lifelong cat mum. 
            Susan nodded knowingly and disappeared into her bedroom, 
            returning with a device no bigger than her hand.
          </p>
          <p className="mb-4" data-id="element-247">
            <em data-id="element-248">
              “Try this,”</em> she said.<em data-id="element-249"> “I have one in every room of my house. They run silently day and night, 
              and I barely even notice them… except for the fact that my allergies are gone.”
            </em>
          </p>
          <p className="mb-4" data-id="element-250">
            Skeptical but desperate, Margaret plugged it into the outlet by her nightstand. 
            For the first time in months, she woke up congestion-free, clear-headed, and breathing easy.
          </p>
          <p className="text-xl text-blue-800" data-id="element-251">
            Her secret? <strong data-id="element-252">Petssey DNRx.</strong>
          </p>
        </div>
        <div className="flex justify-center mb-8" data-id="element-253">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9z8rpX32fv85L6a7AtCyqP/img_2.webp" alt="Young woman giving a blue Petssey DNRx box to an older woman outdoors" className="w-3/4 rounded-lg shadow-md" data-id="element-254" />
        </div>
      </div>
    </section>;
}